import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel/InputLabel';
import Select from '@material-ui/core/Select/Select';
import { FilledInput, MuiThemeProvider, Tooltip, withStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import ListItemText from '@material-ui/core/ListItemText/ListItemText';
import React, { useEffect, useState } from 'react';
import { FILLED_INPUT_MULTI_SELECT_THEME } from 'components/TrustCenter/TrustCenterMuiTheme';
import * as Constants from 'constants/Constants';
import { isBlank, isEmptyList, isNotEmptyList } from 'components/Common/Utils/StringUtils';
import * as actions from 'components/TrustCenter/store/actions';
import { connect } from 'react-redux';
import { isOtherGroupInEditMode } from 'components/TrustCenter/ProviderDetails/Agreement/TMS/Utils/TMSUtils';
import { validateWriteAccess } from 'components/Common/ResourceAccessValidation/ResourceAccessValidation';
import { CHECKBOX_STYLE } from 'theme/CommonTheme';
import EventTypesStyles from './EventTypesStyles';
import FormHelperText from '@material-ui/core/FormHelperText';

const EventTypesDropDown = (props) => {
    const {
        agreements,
        groupName,
        selectedEvents,
        setSelectedEvents,
        trustCenterEvents,
        updateNewAgreementGroup,
        updateExistingAgreementGroup,
        sidebarResource,
        newAgreementGroup,
        existingAgreementGroup,
        isAgreementInEditMode,
        editedAgreements,
        newShipperAgreement,
        newTruckAgreements,
        classes,
        resetEventError,
        trustCenterEventsLoaded,
        setResetEventError,
        isTitanServiceEnabled,
        setIsSaveEnabled
    } = props;

    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);

    const MenuProps = {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
        },
        getContentAnchorEl: null
    };

    const [errorText, setErrorText] = useState({
        isInvalid: false,
        message: ''
    });

    useEffect(() => {
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.TRUSTCENTER_RESOURCE,
                Constants.TRUSTCENTER_FEATURE
            )
        );
    }, [sidebarResource]);

    useEffect(() => {
        if (resetEventError) {
            resetErrorText();
        }
    }, [resetEventError]);

    useEffect(() => {
        if (trustCenterEventsLoaded) {
            if (isEmptyList(trustCenterEvents)) {
                let error = {};

                error.isInvalid = true;
                error.message = 'Cannot edit or create agreements with this provider';

                setErrorText(error);
            } else {
                let error = {};
                if (
                    isNotEmptyList(agreements[groupName]) &&
                    isEmptyList(agreements[groupName][0].event_types)
                ) {
                    error.isInvalid = true;
                    error.message = 'Select atleast an event to keep sharing data';
                    setErrorText(error);
                }
            }
        }
    }, [trustCenterEventsLoaded, trustCenterEvents]);

    const modifyEventTypeObject = (events) => {
        let eventList = [];
        const eventsLength = trustCenterEvents.length;
        const fullEventList = [
            Constants.TRUSTCENTER_ALL_EVENTS,
            ...trustCenterEvents.map((row) => row.message_type)
        ];
        if (
            (selectedEvents.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) === -1 &&
                events.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) > -1) ||
            (selectedEvents.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) === -1 &&
                events.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) === -1 &&
                events.length === eventsLength)
        ) {
            eventList = fullEventList;
        } else if (
            selectedEvents.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) > -1 &&
            events.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) === -1
        ) {
            eventList = [];
        } else if (
            selectedEvents.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) === -1 &&
            events.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) === -1 &&
            events.length < eventsLength
        ) {
            eventList = events;
        } else if (
            selectedEvents.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) > -1 &&
            events.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) > -1 &&
            events.length <= eventsLength
        ) {
            eventList = events.filter((row) => row !== Constants.TRUSTCENTER_ALL_EVENTS);
        }
        return eventList;
    };

    const multiSelectHandleChange = (event) => {
        setResetEventError(false);
        setIsSaveEnabled && setIsSaveEnabled(!isTitanServiceEnabled);
        let eventsList = event.target.value;
        const finalEvents = modifyEventTypeObject(eventsList);
        if (isEmptyList(agreements[groupName])) {
            let tempNewAgreementGroup = { ...newAgreementGroup };
            tempNewAgreementGroup.event_types = finalEvents;
            setSelectedEvents(finalEvents);
            updateNewAgreementGroup(tempNewAgreementGroup);
        } else {
            let tempExistingAgreementGroup = { ...existingAgreementGroup };
            if (isEmptyList(Object.keys(tempExistingAgreementGroup))) {
                tempExistingAgreementGroup[groupName] = {};
            }
            if (tempExistingAgreementGroup.hasOwnProperty(groupName)) {
                tempExistingAgreementGroup[groupName]['event_types'] = finalEvents;
                setSelectedEvents(finalEvents);
            }
            updateExistingAgreementGroup(tempExistingAgreementGroup);
        }
    };

    const multiSelectCustomRenderValue = (selected) => {
        let selectedEvents = selected.filter((event) => event !== Constants.TRUSTCENTER_ALL_EVENTS);
        return selectedEvents.join(', ');
    };

    const multiSelectTooltipValue = (selected) => {
        let selectedEvents = selected.filter((event) => event !== Constants.TRUSTCENTER_ALL_EVENTS);
        return selectedEvents.length > 3 && !selectOpen ? selectedEvents.join(', ') : '';
    };

    const [selectOpen, setSelectOpen] = useState(false);

    const resetErrorText = () => {
        const error = {
            isInvalid: false,
            message: ''
        };
        setErrorText(error);
    };

    const validateSelection = (eventsList) => {
        let error = {};
        if (eventsList.length === 0) {
            error.isInvalid = true;
            error.message = 'Select at least one Event type';
            setErrorText(error);
        } else {
            resetErrorText();
        }
        setSelectOpen(false);
    };

    return (
        <MuiThemeProvider theme={FILLED_INPUT_MULTI_SELECT_THEME}>
            <FormControl>
                <InputLabel
                    htmlFor="Select-an-Event-Type-label"
                    shrink={selectedEvents.length > 0}
                    className={
                        selectedEvents.length > 0
                            ? classes.shrinkedLabelStyle
                            : classes.normalLabelStyle
                    }
                    error={errorText.isInvalid}
                >
                    Select an Event Type*
                </InputLabel>
                <Select
                    labelId="Select-an-Event-Type"
                    id="Select-an-Event-Type"
                    name="Select-an-Event-Type"
                    required
                    multiple
                    variant={'standard'}
                    input={
                        <Tooltip
                            disableHoverListener={selectOpen}
                            title={multiSelectTooltipValue(selectedEvents)}
                            placement={'bottom'}
                        >
                            <FilledInput
                                name="Select-an-Event-Type"
                                id="Select-an-Event-Type-label"
                            />
                        </Tooltip>
                    }
                    value={selectedEvents}
                    onChange={multiSelectHandleChange}
                    onOpen={() => setSelectOpen(true)}
                    onClose={() => validateSelection(selectedEvents)}
                    disabled={
                        (isTitanServiceEnabled &&
                            trustCenterEventsLoaded &&
                            isEmptyList(trustCenterEvents)) ||
                        !isWriteAccessGranted ||
                        isBlank(groupName) ||
                        isNotEmptyList(Object.keys(isAgreementInEditMode)) ||
                        isOtherGroupInEditMode(
                            newAgreementGroup,
                            existingAgreementGroup,
                            editedAgreements,
                            newShipperAgreement,
                            groupName,
                            isAgreementInEditMode,
                            newTruckAgreements
                        )
                    }
                    renderValue={(selected) => multiSelectCustomRenderValue(selected)}
                    label={'Select an Event Type'}
                    MenuProps={MenuProps}
                >
                    <MenuItem
                        key={Constants.TRUSTCENTER_ALL_EVENTS}
                        value={Constants.TRUSTCENTER_ALL_EVENTS}
                    >
                        <Checkbox
                            checked={selectedEvents.indexOf(Constants.TRUSTCENTER_ALL_EVENTS) > -1}
                            classes={CHECKBOX_STYLE}
                        />
                        <ListItemText primary={Constants.TRUSTCENTER_ALL_EVENTS} />
                    </MenuItem>
                    {trustCenterEvents.map((row, key) => (
                        <MenuItem key={key} value={row.message_type}>
                            <Checkbox
                                checked={
                                    isNotEmptyList(selectedEvents)
                                        ? selectedEvents.indexOf(row.message_type) > -1
                                        : false
                                }
                                classes={CHECKBOX_STYLE}
                            />
                            <ListItemText primary={row.message_type} />
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText>{errorText.message}</FormHelperText>
            </FormControl>
        </MuiThemeProvider>
    );
};

const mapStateToProps = (state) => {
    return {
        agreements: state.agreement.agreements,
        newShipperAgreement: state.agreement.newShipperAgreement,
        newAgreementGroup: state.agreement.newAgreementGroup,
        existingAgreementGroup: state.agreement.existingAgreementGroup,
        editedAgreements: state.agreement.editedAgreements,
        isAgreementInEditMode: state.agreement.isAgreementInEditMode,
        newTruckAgreements: state.agreement.newTruckAgreements,
        trustCenterEventsLoaded: state.agreement.trustCenterEventsLoaded,
        isTitanServiceEnabled: state.agreementV2.isTitanServiceEnabled,
        sidebarResource: state.header.sidebarResource
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateNewAgreementGroup: (agreementGroupData) =>
            dispatch(actions.updateNewAgreementGroup(agreementGroupData)),
        updateExistingAgreementGroup: (editedExistingAgreementGroup) => {
            dispatch(actions.updateExistingAgreementGroup(editedExistingAgreementGroup));
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(EventTypesStyles)(EventTypesDropDown));
